module.exports = __webpack_public_path__ + "static/media/Ekstra-Info.fc282411.png";